import { render, staticRenderFns } from "./OAuthRedirect.vue?vue&type=template&id=202f2882"
import script from "./OAuthRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthRedirect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports